/* eslint-disable complexity */
import { createNamespacedHelpers } from "vuex";
import { EditIcon, ChevronUpIcon, ChevronDownIcon } from "vue-feather-icons";
import { Fragment } from "vue-frag";
import BaseDropdown from "@/components/baseDropdown/baseDropdown.vue";
import TrackedItemCard from "@/components/trackedItemCard/trackedItemCard.vue";
import SetItemsForTrackModal from "@/components/setItemsForTrack/setItemsForTrack.vue";
import AddRemoveTrackedItem from "@/components/addRemoveTrackedItem/addRemoveTrackedItem.vue";
import { SettingsService } from "@/services/settingsApi";

const { mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	{ mapGetters: userGetters } = createNamespacedHelpers("user");

import { REQUEST_STATE, STATUS_CODE } from "@/enums";

// eslint-disable-next-line one-var
const Status = {
		all: "all",
		active: "actively_tracked",
		pending: "pending",
		hidden: "hidden",
		stopped: "stopped",
	},
	LESS_ROWS_LIMIT = 5;

export default {
	components: {
		EditIcon,
		ChevronUpIcon,
		ChevronDownIcon,
		Fragment,
		BaseDropdown,
		TrackedItemCard,
		SetItemsForTrackModal,
		AddRemoveTrackedItem,
	},

	data() {
		return {
			REQUEST_STATE,
			state: REQUEST_STATE.LOADING,
			items: null,

			statusList: Object.values(Status),
			activeStatus: Status.active,
			showStatusList: false,

			showSeeMoreLess: false,
			seeMoreToggled: false,
			showItemsForTrackModal: false,
			showAddModal: false,
			// eslint-disable-next-line object-curly-newline
			itemToEditStart: {},
		};
	},

	methods: {
		fetchItems,
		onSelectStatus,
		toggleDropdown,
		toggleSeeMore,
		clickEditStartDate,
		editStartDate,
	},

	computed: {
		...userGetters(["activeOutlet"]),
		...brandingGetters(["colors"]),
		table,
	},

	mounted() {
		this.fetchItems();

		this.$eventBus.$on("reloadTrackedItemsData", this.fetchItems);
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadTrackedItemsData", this.fetchItems);
	},
};

function table() {
	if (!this.items) return [];

	let filteredItems;

	switch (this.activeStatus) {
		case Status.pending:
			filteredItems = this.items.filter((item) => item.pending);
			break;
		case Status.active:
			filteredItems = this.items.filter((item) => item.active);
			break;
		case Status.hidden:
			filteredItems = this.items.filter((item) => !item.active);
			break;
		case Status.stopped:
			filteredItems = this.items.filter((item) => item.stopped);
			break;
		default:
			filteredItems = this.items;
			break;
	}

	/*
	 * TODO: order filteredItems based on item's last updated date;
	 * at the time of writing this comment that info is not available
	 */

	this.showSeeMoreLess = filteredItems.length > LESS_ROWS_LIMIT;
	if (this.showSeeMoreLess && !this.seeMoreToggled) filteredItems = filteredItems.slice(0, LESS_ROWS_LIMIT);

	return filteredItems;
}

async function fetchItems() {
	this.state = REQUEST_STATE.LOADING;

	try {
		const { data } = await this.$api.getTrackedItemsTable();
		this.items = Object.values(data);
		this.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response?.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
		else this.state = REQUEST_STATE.ERROR;
	} finally {
		this.$emit("notifyLoaded");
	}
}

async function onSelectStatus(status) {
	this.activeStatus = status;
	this.showStatusList = false;

	// TODO: propagate to other components, abstract if needed...
	this.seeMoreToggled = false;
}

function toggleDropdown() {
	this.showStatusList = !this.showStatusList;
}

function toggleSeeMore() {
	// TODO: propagate to other components, abstract if needed...
	this.seeMoreToggled = !this.seeMoreToggled;
}

function clickEditStartDate(item) {
	this.showAddModal = true;
	this.itemToEditStart = {
		label_id: item.label_id,
		start_date: this.$moment(item.start_date, "DD.MM.YYYY"),
		end_date: item.end_date ? this.$moment(item.end_date, "DD.MM.YYYY") : null,
		translations: item.description,
	};
}

async function editStartDate(labelId, date) {
	try {
		await SettingsService.setTrackedLabelDates({
			label: labelId,
			startDate: this.$moment(date).format("YYYY-MM-DD"),
		});
		this.$eventBus.$emit("reloadTrackedItemsData");
		this.$emit("close");
	} catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal",
		});
	}
}
